import styles from './ReviewRezAddOn.module.css'
import { type FC } from 'react'
import IntlHelper from '../../../helper/IntlHelper'
// import { useDispatch, useSelector } from 'react-redux'
// import type { RootState } from '../../../store/store'
// import { updateReservationAction } from '../../../store/reservationSlice'
import type { ReservationRequest } from '../../../api/data/ReservationRequest'

interface ReviewRezAddOnProps {
  addOnName: string
  addOnPrice: string
  onClose?: (reservation: ReservationRequest) => Promise<void>
  rateFee?: string
  rateFrequency?: string
  rateType?: string
}

const ReviewRezAddOn: FC<ReviewRezAddOnProps> = ({ addOnName, addOnPrice, onClose, rateFee, rateFrequency, rateType }: ReviewRezAddOnProps) => {
  const intlHelper = new IntlHelper()
  // const reservation = useSelector((state: RootState) => state.reservationSlice.reservation)

  // const dispatch = useDispatch()

  //  async function handleCloseClick(name: string): Promise<void> {
  //    remove this add on from the fees
  //    const updatedReservation: ReservationRequest = { ...reservation, fees: reservation?.fees?.filter((x) => x !== name) }

  //    Change the reservation object on the store
  //    dispatch(updateReservationAction(updatedReservation))

  //    if (onClose !== undefined) {
  //      await onClose(updatedReservation)
  //    }
  //  }

  return (
    <div className={styles.CheckoutSummaryItem}>
      <div className={styles.CheckoutSummaryItemName}>{addOnName}
      </div>
      <div className={styles.CheckoutSummaryItemPrice}>
        <p className={styles.CheckoutSummaryItemTitle}>{isNaN(Number(addOnPrice)) ? addOnPrice : intlHelper.CurrencyFormat(Number(addOnPrice))}</p>
        <small>
          {rateFrequency} {rateType} @ {intlHelper.CurrencyFormat(Number(rateFee))}
        </small>
      </div>
    </div>
  )
}
export default ReviewRezAddOn
